module.exports = __webpack_public_path__ + "static/media/badgeAffordability.ab9d1fd5.png";